<template>
  <div class="m-2" :class="[darkMode ? 'discrete-shadow-light' : 'discrete-shadow']">
    <table ref="dataTable" id="dataTable" class="m-0 table table-striped table-hover" :class="[darkMode ? 'table-dark' : 'table-light']">
      <thead>
      <tr>
        <th>TITLE</th>
        <th>CENSOR</th>
        <th>DESCRIPTION</th>
        <th>EPISODES</th>
        <th>MAL</th>
        <th>ANIDB</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
        <table-data v-for="item in list"
                    :key="item.id"
                    :id="item.id"
                    :title="item.title"
                    :description="item.description"
                    :episodes="item.episodes"
                    :uncensored="item.uncensored"
                    :mal="item.mal"
                    :anidb="item.anidb"
                    :dark-mode="darkMode"
        >
        </table-data>
      </tbody>
    </table>
    <table-data class="d-none"></table-data>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {route} from "@/constants";
import TableData from "@/components/TableData";
import Podtable from "podtable";

export default {
  name: "List",
  components: {TableData},
  props: {
    darkMode: Boolean,
    list: Array
  },
  beforeMount() {
    if (this.currentUser.homePage === route.COVERS) {
      this.$router.push({name: route.COVERS})
    }
  },
  mounted() {
    new Podtable(this.$refs.dataTable, {
      keepCell: [1],
      priority: [2, 5, 4],
      event: false
    });
  },
  computed: {
    ...mapGetters([
      "currentUser"
    ])
  }
}
</script>

<style scoped>
@import "~podtable/dist/podtable.css";

.discrete-shadow {
  box-shadow: rgba(60, 64, 67, 0.3) 0 1px 2px 0, rgba(60, 64, 67, 0.15) 0 1px 3px 1px;
}

.discrete-shadow-light {
  box-shadow: rgba(160, 164, 167, 0.3) 0 1px 2px 0, rgba(160, 164, 167, 0.15) 0 1px 3px 1px;
}
</style>

<style>
#podtable-container table.show-toggle .toggle::before,
#podtable-container table.show-toggle .main-toggle::before {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  content: "\f078";
  margin: 0 !important;
  position: relative !important;
  background: none;
  border: none;
  border-radius: 0;
  display: inline-block;
  left: 0;
  z-index: 1;
  color: inherit !important;
}

#podtable-container table .child .child-grid-row .child-grid-col > div:nth-child(2) {
  color: inherit !important;
}
</style>
